module.exports = __webpack_public_path__ + "/images/embarazada.757c2e8.jpg";